import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import axios from 'axios';
import { App } from './App';
import { useLanguageStore } from './i18n';
import './styles/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      // Do not retry client errors such as 401/403/404
      retry: (failureCount, error) =>
        failureCount < 2 && !(axios.isAxiosError(error) && error.response && error.response.status < 500),
    },
  },
});

/** A new language renders the whole app again, so every text is read in it (the data cache stays). */
function LanguageRoot() {
  const language = useLanguageStore((s) => s.language);
  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);
  return <App key={language} />;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <LanguageRoot />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
